import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_white",
  "use": "close_white-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close_white\">\n<path d=\"M12.6673 4.27337L11.7273 3.33337L8.00065 7.06004L4.27398 3.33337L3.33398 4.27337L7.06065 8.00004L3.33398 11.7267L4.27398 12.6667L8.00065 8.94004L11.7273 12.6667L12.6673 11.7267L8.94065 8.00004L12.6673 4.27337Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol